<template>
  <div>
    <div class="weui_cell" v-if="shell">
      <div class="weui_cell_bd weui_cell_primary">
        <p>{{title}}</p>
      </div>
      <div class="weui_cell_ft" v-if="!readonly" style="font-size:0">
        <a @click="sub" class="vux-number-selector vux-number-selector-sub" :class="{'vux-number-disabled':disabledMin}">-</a>
        <input @focus="focus($event)" @blur="blur($event)" v-model="currentValue" :name="name" class="vux-number-input" :style="{width: width+'px'}" :readonly="!fillable"/>
        <a @click="add" class="vux-number-selector vux-number-selector-plus" :class="{'vux-number-disabled':disabledMax}">+</a>
      </div>
      <div class="weui_cell_ft" v-else>
        {{currentValue}}
      </div>
    </div>
    <div v-else>
      <div v-if="!readonly">
        <span @click="sub" style="float:left;">
          <slot name="sub">
            <a class="vux-number-selector vux-number-selector-sub" :class="{'vux-number-disabled':disabledMin}">-</a>
          </slot>
        </span>
        <input @focus="focus($event)" @blur="blur($event)" v-model="currentValue" :name="name" class="vux-number-input" :class="inputClasses" :readonly="!fillable"/>
        <span @click="add">
          <slot name="add">
            <a class="vux-number-selector vux-number-selector-plus" :class="{'vux-number-disabled':disabledMax}">+</a>
          </slot>
        </span>
      </div>
      <div v-else>
        {{currentValue}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    min: Number,
    max: Number,
    step: {
      type: Number,
      default: 1
    },
    value: {
      type: [Number, String],
      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 50
    },
    readonly: {
      type: Boolean,
      default: false
    },
    shell: {
      type: Boolean,
      default: true
    },
    inputClasses: {
      type: String,
      default: ''
    },
    lockMin: {
      type: Boolean,
      default: false
    },
    lockMax: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    disabledMin () {
      return typeof this.min === 'undefined' ? false : +this.currentValue <= this.min
    },
    disabledMax () {
      return typeof this.max === 'undefined' ? false : +this.currentValue >= this.max
    }
  },
  data () {
    return {
      currentValue: this.value
    }
  },
  watch: {
    value (nVal, oVal) {
      if (!/^[+-\d]?[\d]*(\.[\d]*)?$/.test(this.value)) {
        this.value = '0.00'
      }
      this.currentValue = this.value
    },
    currentValue (newValue, old) {
      if (typeof this.currentValue === 'string') {
        let isSymbol = /[+-.]/.test(this.currentValue.substr(0, 1))
        if (isSymbol) {
          this.currentValue = this.currentValue.substr(0, 1) + this.currentValue.substr(1).replace(/[^\d.]/g, '')
        } else {
          this.currentValue = this.currentValue.replace(/[^\d.]/g, '')
        }
      }
      if (this.min && +this.currentValue < this.min && !this.lockMin) {
        this.currentValue = this.min
      }
      if (this.max && +this.currentValue > this.max && !this.lockMax) {
        this.currentValue = this.max
      }
      this.$emit('on-change', this.currentValue)
      this.$emit('input', this.currentValue)
    }
  },
  methods: {
    focus (e) {
      this.$emit('on-focus', e)
    },
    blur (e) {
      this.$emit('on-blur', e)
    },
    add () {
      if (!this.disabledMax) {
        this.currentValue = +this.currentValue + this.step
        this.currentValue = this.currentValue.toFixed(2)
      }
    },
    sub () {
      if (!this.disabledMin) {
        this.currentValue = +this.currentValue - this.step
        this.currentValue = this.currentValue.toFixed(2)
      }
    }
  }
}
</script>

<style lang="less">
@import '../../styles/cui/widget/cui_cell/cui_cell_global';

.vux-number-input {
  float:left;
  height:20/@w;
  font-size:20/@w;
  color: #666;
  appearance: none;
  border:1px solid #ececec;
  padding:3/@w 0;
  text-align:center;
  border-radius: 1px;
}
.vux-number-selector {
  float:left;
  height:20/@w;
  font-size:25/@w;
  line-height:18/@w;
  color:#5890ff;
  border:1px solid #ececec;
}
.vux-number-selector.vux-number-disabled{
  color:#ccc;
}
.vux-number-selector-sub {
  border-right:none;
  padding:3/@w 10/@w;
  border-radius:2px 0 0 2px;
}
.vux-number-selector-plus {
  border-left:none;
  margin-right: 5/@w;
  padding:3/@w 8/@w;
  border-radius:0 2/@w 2/@w 0;
}
</style>



// WEBPACK FOOTER //
// x-number.vue?6ecd18f6